/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Step_SourceInputs */

const cs_ebr_step_source = /** @type {(inputs: Ebr_Step_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj a rozsah`)
};

const en_ebr_step_source = /** @type {(inputs: Ebr_Step_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source & scope`)
};

/**
* | output |
* | --- |
* | "Source & scope" |
*
* @param {Ebr_Step_SourceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_step_source = /** @type {((inputs?: Ebr_Step_SourceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Step_SourceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_step_source(inputs)
	return cs_ebr_step_source(inputs)
});